import type { Value } from '@gitbook/slate';
import { ActionableContainer, Description, Link } from '@gitbook/spine-react';

import { NavigationLink } from '../../navigation';
import { createDocumentationURL } from '../../utils';
import { RichTextarea, RichTextareaSurface } from '../BasicEditor';

/**
 * Input for custom instructions for the translation.
 */
export function TranslationInstructionInput(props: {
    organizationId: string;
    value: Value;
    onChange: (value: Value) => void;
}) {
    const { organizationId, value, onChange } = props;

    return (
        <ActionableContainer>
            <Description>
                Customize how the AI translates your content by providing specific instructions
                (particular writing style, tone of voice, etc).{' '}
                <Link
                    href={createDocumentationURL('creating-content/translations')}
                    target="_blank"
                >
                    Learn more
                </Link>
                .
            </Description>
            <RichTextareaSurface>
                <RichTextarea
                    className="px-3 py-2"
                    value={value}
                    onChange={onChange}
                    placeholder="Enter custom instructions for the translation"
                    minRows={4}
                    maxRows={12}
                />
            </RichTextareaSurface>
            <Description>
                For providing, term-specific translations, use the{' '}
                <NavigationLink
                    to={{
                        current: {
                            type: 'org_settings',
                            organization: organizationId,
                            tab: { type: 'translations', view: 'glossary' },
                        },
                    }}
                >
                    glossary
                </NavigationLink>
                .
            </Description>
        </ActionableContainer>
    );
}
